import text from '../constants.js';
import {createElement, numberOnly} from '../utils.js';
import renderControl from './renderControl.js';

export default function renderComponent(componentElement, props, data, obj) {
    const label = createElement('div', {
        className: obj.mode == 1 ? 'x-label x-preview' : 'x-label',
        innerText: data.label
    });

    if(obj.mode == 1){
        label.title = text.QUESTIONS;
        label.contentEditable = true
    }   
    
    componentElement.appendChild(label);

    const answer = createElement('div', {
        className: 'x-answer',
    });        
    componentElement.appendChild(answer);    

    if(obj.mode == 3 && data.correct_answer) {
        const ca = Array.isArray(data.correct_answer) ? data.correct_answer.join(', ') : data.correct_answer;
        if(ca) {
            // For blank line
            componentElement.appendChild(createElement('div', {}));
            
            componentElement.appendChild(createElement('div', {
                className: 'x-correct-answer',
                innerHTML: text.CORRECT_ANSWER + ca
            }))    
        }
    }

    const help_placeholder = obj.mode == 1 ? (data.help || text.HELP) : (data.help ?? text.HELP);
    const help = createElement('div', {
        className: obj.mode == 1 ? 'x-help x-preview' : 'x-help',
        innerText: help_placeholder
    });

    componentElement.appendChild(help);    
    if (obj.mode != 2){
        if(obj.mode == 1) help.contentEditable = true;
        const footer = createElement('div', {
            className: 'x-footer',
        });
        let componentHasFooter = false;
        if(obj.scoring && (obj.mode == 3 || obj.mode == 4)){
            componentHasFooter = true;
            const asses_point = createElement('span', {
                className: 'x-point-assessment',
                title: text.ASSESS_POINT,
                innerText: data.assess_point || 0                        
            });
            if(obj.mode == 3){
                asses_point.contentEditable = true;
                asses_point.addEventListener('blur', (e) => {
                    const el = e.target;
                    const maxPointEl = el.parentNode.querySelector('.x-point');
                    const maxPoint = parseInt(maxPointEl.innerText);
                    if(parseInt(el.innerText) > maxPoint) {
                        el.innerText = maxPoint;
                    }

                    const pointEls = obj.content.querySelectorAll('.x-point-assessment');
                    obj.curValue.innerText = Array.from(pointEls).reduce((total, d) => {
                        const value = Number(d.innerText);
                        return total + (isNaN(value) ? 0 : value);
                    }, 0);
                })
                asses_point.addEventListener('keydown', numberOnly)
            } 
            footer.appendChild(asses_point)
            footer.appendChild(createElement('span', {
                className: 'x-separator'
            }))
        }   
        if(obj.scoring){
            const point = createElement('span', {
                className: 'x-point',
                title: text.MAX_POINT,
                innerText: data.max_point || 10
            });
            footer.appendChild(point);
            if(obj.mode == 1) {
                point.contentEditable = true;
                point.addEventListener('keydown', numberOnly);
            }        
        } 
        if(obj.mode == 1){
            footer.appendChild(renderControl(componentElement, data));
            componentHasFooter = true;
        } 
        if(componentHasFooter) componentElement.appendChild(footer);    
    }            
    obj.content.appendChild(componentElement);        
    return answer;
};